import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { useUser } from '@edwin/react-sdk'

import { useSpring, animated } from 'react-spring'

import { AMarkdown } from '../atoms/AMarkdown'

_.templateSettings.interpolate = /{{([\s\S]+?)}}/g

export const MChatInfographicAnimatedNumber = ({
  animateNumberFrom = '0',
  animateNumberTo,
  descriptionMarkdown,
  reset = false,
}) => {
  const { user } = useUser()
  const { val } = useSpring({ val: animateNumberTo, from: { val: animateNumberFrom } })

  return (
    <div className="min-w-[180px] py-3.5 px-4">
      <animated.div className="mt-2 mb-5 text-5xl font-bold text-center">
        {val.to(val => Math.floor(val))}
      </animated.div>
      <AMarkdown>{_.template(descriptionMarkdown)({ user })}</AMarkdown>
    </div>
  )
}

MChatInfographicAnimatedNumber.propTypes = {
  descriptionMarkdown: PropTypes.string,
  animateNumberFrom: PropTypes.number,
  animateNumberTo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}
